import React from "react";
import "./ProductSteel.css";
import conveyor from "./image/ConveyorChain.jpg";
import conveyorvarnising from "./image/ConveyorChainVarnising.jpg";
import cooling from "./image/CoolingBedConveyorChain.jpg";
import drawbech from "./image/DrawBechChain.jpg";
import mandralbar from "./image/MandrelBarInsertChain.jpg";
import mandralextractor from "./image/MandrelExtractorChain.jpg";
import shellpusher from "./image/ShellPusherChain.jpg";
import shellpusher4101 from "./image/ShellPusherChain4101.jpg";

const ProductSteel = () => {
  return (
    <div>
      <div className="steelp">
        <p className="p">Steel Industry</p>
        <div className="p2">
          {/* <p>Swajit Engineering Pvt.Ltd: &gt; Products &gt; Steel Industry</p> */}
        </div>
      </div>

    <div className="steel">
      <div className="auimg">
        <figure>
          <img src={conveyor} alt="Conveyor Chain SWAJIT 4601"/>
          <figcaption>Conveyor Chain SWAJIT 4601</figcaption>
        </figure>
      </div>

      <div className="stimg">
        <figure>
          <img src={conveyorvarnising} alt="Conveyor Chain for Varnishing Machine SWAJIT 4401"/>
          <figcaption>Conveyor Chain for Varnishing Machine SWAJIT 4401</figcaption>
        </figure>
      </div>

      <div className="stimg">
        <figure>
          <img src={cooling} alt="CoolingBed Conveyor Chain SWAJIT 4501"/>
          <figcaption>CoolingBed Conveyor Chain SWAJIT 4501</figcaption>
        </figure>
      </div>
      

      <div className="stimg">
        <figure>
          <img src={drawbech} alt="Draw Bech Chain SWAJIT 4001"/>
          <figcaption>Draw Bech Chain SWAJIT 4001</figcaption>
        </figure>
      </div>

      </div>

        <div className='steel-two'>
      <div className="stmg">
        <figure>
          <img src={mandralbar} alt="Mandrel Bar Insert Chain SWAJIT 4301"/>
          <figcaption>Mandrel Bar Insert Chain SWAJIT 4301</figcaption>
        </figure>
      </div>
      <div className="stimg">
        <figure>
          <img src={mandralextractor} alt="Mandrel Extractor Chain SWAJIT 4201"/>
          <figcaption>Mandrel Extractor Chain SWAJIT 4201</figcaption>
        </figure>
      </div>

      <div className="stimg">
        <figure>
          <img src={shellpusher} alt="Shell Pusher Chain"/>
          <figcaption>Shell Pusher Chain</figcaption>
        </figure>
      </div>

      <div className="stimg">
        <figure>
          <img src={shellpusher4101} alt="Shell Pusher Chain SWAJIT 4101"/>
          <figcaption>Shell Pusher Chain SWAJIT 4101</figcaption>
        </figure>
      </div>

      </div>

    </div>
  );
};

export default ProductSteel;
